import React, { FC } from 'react';

const IconReceipt: FC = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.5 0.5H2.5C2.23478 0.5 1.98043 0.605357 1.79289 0.792893C1.60536 0.98043 1.5 1.23478 1.5 1.5V15.5L4 13.5L6 15.5L8 13.5L10 15.5L12 13.5L14.5 15.5V1.5C14.5 1.23478 14.3946 0.98043 14.2071 0.792893C14.0196 0.605357 13.7652 0.5 13.5 0.5Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M4.5 9.5H7.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M8 6.5C8.82843 6.5 9.5 5.82843 9.5 5C9.5 4.17157 8.82843 3.5 8 3.5C7.17157 3.5 6.5 4.17157 6.5 5C6.5 5.82843 7.17157 6.5 8 6.5Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M11.5 9.5H10.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
  </svg>

);

export default IconReceipt;
